import { styled } from '@mui/material/styles';

import Base02Container from 'src/components/Base02Container';

export const Container = styled(Base02Container)(({ theme }) => ({
  color: theme.colors.base01,

  marginTop: '1.6rem',
}));

export const TitleContainer = styled('div')(({ theme }) => ({
  color: theme.colors.base01,
}));

export const InfoTextContainer = styled('div')(({ theme }) => ({
  width: '100%',

  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',

  color: theme.colors.base01,
}));

export const ValidatorSelectButton = styled('button')(({ theme }) => ({
  width: '100%',

  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',

  padding: '0',

  backgroundColor: 'transparent',
  border: 'none',
  color: theme.colors.base01,

  '&:hover': {
    opacity: '0.7',

    cursor: 'pointer',
  },
}));

export const ValidatorSelectLeftContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',

  columnGap: '0.2rem',

  color: theme.colors.base02,
}));

export const ValidatorSelectRightContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',

  columnGap: '0.6rem',
});

export const ImageContainer = styled('div')({
  '& > img': {
    width: '2rem',
    height: '2rem',
  },
});

export const InfoBodyContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',

  rowGap: '1.4rem',

  marginTop: '1.6rem',
});

export const Base02TextContainer = styled('div')(({ theme }) => ({
  color: theme.colors.base02,
}));
export const RightChevronIconContainer = styled('div')(({ theme }) => ({
  width: '2rem',
  height: '2rem',

  marginTop: '0.2rem',

  '& > svg': {
    width: '2rem',
    height: '2rem',

    '& > path': {
      fill: theme.colors.base01,
    },
  },
}));

export const AmountContainer = styled('div')({
  display: 'flex',
  alignItems: 'flex-end',
});
